import universal from 'react-universal-component';

export default universal(() => import('./AktaryTechPlaceholderComponent'));



// WEBPACK FOOTER //
// ./src/app/views/AktaryTechPlaceholderComponent/index.js